import "./home.css";

const Home = () => (
  <>
    <div className={"containerHome"}></div>
    <div className={"home"}>
      <div id={"textHome"} className={"textHome"}>
        Bienvenue sur Jennifer WP, mon portfolio en ligne !
        <br />
        Développeuse web spécialisée située à Toulouse, je suis à la recherche
        de nouvelles missions de programmation ou d'un poste en CDI 💻
        <br />
        Vous y trouverez toutes les informations essentielles sur mon parcours,
        mes compétences et mes expériences professionnelles.
        <br />
        Bonne visite !
      </div>
    </div>
  </>
);

export { Home };
